import app from 'flarum/forum/app';

const pattern = /\[\[\[([^\[\]\r\n]+)\]\]\]|\[\[([^\[\]\r\n]+)\]\]/g;
function route() {
  const user = app.session.user;
  if (!user) return 'roglo';
  const groups = typeof user.groups === 'function' ? user.groups() : [];
  return (groups || []).some(group => String(group.id()) === '5') ? 'roglo_w' : 'roglo_f';
}
function parse(triple, double) {
  let label, query;
  if (triple !== undefined) {
    const slash = triple.indexOf('/');
    const page = (slash < 0 ? triple : triple.slice(0, slash)).trim();
    if (!page) return null;
    label = slash < 0 ? page.split(':').pop() : triple.slice(slash + 1);
    query = `lang=fr;m=NOTES;f=${encodeURIComponent(page)}`;
  } else if (double.startsWith('w:')) {
    const payload = double.slice(2), slash = payload.indexOf('/');
    const wizard = (slash < 0 ? payload : payload.slice(0, slash)).trim();
    if (!wizard) return null;
    label = slash < 0 ? wizard : payload.slice(slash + 1);
    query = `lang=fr;m=WIZNOTES;f=${encodeURIComponent(wizard)}`;
  } else {
    const fields = double.split('/');
    if (fields.length < 2 || fields.length > 4) return null;
    const [first, last] = fields.map(s => s.trim());
    if (!first || !last) return null;
    let oc = '0'; label = `${first} ${last}`;
    if (fields.length === 3) {
      if (/^\d+$/.test(fields[2])) oc = fields[2];
      else label = fields[2];
    } else if (fields.length === 4) {
      if (!/^\d+$/.test(fields[2])) return null;
      oc = fields[2]; label = fields[3] || label;
    }
    query = `lang=fr;p=${encodeURIComponent(first)};n=${encodeURIComponent(last)};oc=${encodeURIComponent(oc)}`;
  }
  if (!label) return null;
  return { label, query };
}
function convert(node) {
  if (!node.nodeValue || node.nodeValue.indexOf('[[') < 0) return;
  const content = node.nodeValue;
  pattern.lastIndex = 0;
  let match, last = 0, changed = false;
  const fragment = document.createDocumentFragment();
  while ((match = pattern.exec(content))) {
    const parsed = parse(match[1], match[2]);
    if (!parsed) continue;
    fragment.appendChild(document.createTextNode(content.slice(last, match.index)));
    const a = document.createElement('a');
    a.href = `https://roglo.eu/${route()}?${parsed.query}`;
    a.textContent = parsed.label;
    fragment.appendChild(a);
    last = pattern.lastIndex;
    changed = true;
  }
  if (!changed) return;
  fragment.appendChild(document.createTextNode(content.slice(last)));
  node.parentNode.replaceChild(fragment, node);
}
function scan(root) {
  if (!root) return;
  const bodies = [];
  if (root.nodeType === 1 && root.matches('.Post-body')) bodies.push(root);
  if (root.querySelectorAll) root.querySelectorAll('.Post-body').forEach(el => bodies.push(el));
  for (const body of bodies) {
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        return parent && !parent.closest('a, code, pre, textarea, script, style, .roglo-linker-ignore') && node.nodeValue.includes('[[')
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(convert);
  }
}
app.initializers.add('roglo-linker', () => {
  const start = () => {
    scan(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') {
          const parent = record.target.parentElement;
          if (parent && parent.closest('.Post-body')) scan(parent.closest('.Post-body'));
        }
        record.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const body = node.closest && node.closest('.Post-body');
            if (body) scan(body);
            else scan(node);
          }
        });
      }
    });
    observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
});
